import Papa from 'papaparse';
emptyValue = (value, callback, field) ->
  if (value.length > 0) 
    callback(true)
  else
    alert(field + ' is a required field')
    callback(false)

to_csv = (workbook,type) ->
  result = []
  workbook.SheetNames.forEach((sheetName) ->
    csv = []
    switch type
      when 'xls'
        csv = XLS.utils.sheet_to_csv(workbook.Sheets[sheetName])
      when 'xlsx'
        csv = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName])
    if csv.length > 0
      result.push(csv)

  )
  return result.join("\n")


read_workbook = (workbook) ->
  result = []
  workbook.SheetNames.forEach((sheetName) ->
    sheet = workbook.Sheets[sheetName]
    if !!sheet['!ref']
      ref = sheet['!ref'].split(":")
      name_identifier = ref[0].match(/[A-Z]*/)[0]
      description_identifier = ref[1].match(/[A-Z]*/)[0]
      range_start = parseInt(ref[0].match(/[0-9]*$/)[0])
      range_end = parseInt(ref[1].match(/[0-9]*$/)[0])
      while range_start <= range_end
        if !!sheet["#{name_identifier}#{range_start}"] && !!sheet["#{description_identifier}#{range_start}"]
          result.push({name: sheet["#{name_identifier}#{range_start}"].v, description: sheet["#{description_identifier}#{range_start}"].v})
        range_start = range_start + 1
  )
  return result

$("#glossary-words-import-form").submit (e) ->
  e.preventDefault()
  $("#start-import-button").val("Please Wait ..")
  $("#start-import-button").attr('disable',true)
  $("#start-import-button").css('pointer-events',"none")
  $("#clear-import-data-button").hide()
  $(".words").empty()
  $.post("#{$(this).attr('action')}.js",$(this).serialize()).done((data,textStatus,jqXHR) ->
    $("#start-import-button").attr('disable',false)
    $("#start-import-button").css('pointer-events',"all")
    $("#start-import-button").val("Start Import")
    $("#clear-import-data-button").hide()
    $("#glossary-words-import-form")[0].reset())

$("#clear-import-data-button").click (e) ->
  e.preventDefault()
  if confirm("Are you sure you want to clear loaded data?")
    location.reload()
    
$('#glossary_import_type').change (e) ->
  if (($('#glossary_import_type').val() == "Translate existing") || ($('#glossary_import_type').val() == "Update existing"))
    $('#glossary-select-category').hide()
  else
    $('#glossary-select-category').show()
    
$("#words_to_import").change (e) ->
  add_list = null
  file = null 
  reader = null
  add_list = $(this)
  file = $(this)[0].files[0]
  colHeaders = ['Name', 'Description']
  if file
    reader = new FileReader()
    file_type = null
    file_name_parts = file.name.split(".")
    if file_name_parts[file_name_parts.length - 1] == "csv"
      reader.readAsText(file)
      file_type = 'csv'
    else 
      if file_name_parts[file_name_parts.length - 1] == "xlsx"
        reader.readAsArrayBuffer(file)
        file_type = "xlsx"
      else 
        if file_name_parts[file_name_parts.length - 1] == "xls"
          reader.readAsArrayBuffer(file)
          file_type = "xls"
      
    unless !!file_type
      alert("Please select a CSV or Excel (xlsx) file.")
      e.preventDefault()
      $(this).val("")
      return
    else
      $("input[type='submit']").show()
      $("#clear-import-data-button").show()

    reader.onload = (ee) ->
      imported_words_data = []
      switch file_type
        when 'csv'
          words_data = Papa.parse(ee.target.result, {}).data
          for word in words_data
            if !!word[0] && !!word[1]
              imported_words_data.push({
                name: word[0],
                description: word[1]
              })
        when 'xlsx'
          binary = ""    
          bytes = new Uint8Array(ee.target.result)
          length = bytes.byteLength;
          i = 0
          while i < length
            binary += String.fromCharCode(bytes[i])
            i = i + 1

          temp1 = XLSX.read(binary, {type: 'binary'})
          imported_words_data = read_workbook(temp1)
        when 'xls'
          binary = ""    
          bytes = new Uint8Array(ee.target.result)
          length = bytes.byteLength;
          i = 0
          while i < length
            binary += String.fromCharCode(bytes[i])
            i = i + 1
          temp1 = XLS.parse_xlscfb(XLS.CFB.read(binary, {type: 'binary'}))
          imported_words_data = read_workbook(temp1)
        else
          alert("Please use either Excel or CSV file")
          return


      $('#words').val(JSON.stringify(imported_words_data))

  return
